import { Box, Button, styled, Typography } from '@mui/material';
import { useCollection } from '@/providers/CollectionProvider';
import { useModal } from '@/hooks/useModal';
import { ModalType } from '@/types/modals';
import analytics from '@/utils/analytics/analyticsInstance';
import BaseModal from '../BaseModal';
import LogoImage from '@/assets/images/findies-logo-dark.png';
import config from '@/types/config';

const GradientContainer = styled(Box)(() => ({
  borderRadius: 24,
  padding: 4,
  background:
    'radial-gradient(120% 60% at 50% 105%, #ffd666 0%, rgba(255,214,102,0.65) 22%, rgba(255,214,102,0) 58%), linear-gradient(180deg, #61a3ff 0%, #8b90c2 32%, #d1848f 58%, #ee9566 78%,#f2b450 100%)',
}));

const Container = styled(Box)(() => ({
  borderRadius: 20,
  backgroundColor: 'white',
}));

const BodyContainer = styled(Box)(() => ({
  padding: '24px 24px 16px 24px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 16,
}));

const ButtonContainer = styled(Box)(() => ({
  padding: '0 24px 24px 24px',
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
}));

const Logo = styled('img')(() => ({
  width: 96,
  height: 24,
}));

export const OpenAppModal = () => {
  const { closeModal } = useModal(ModalType.OpenAppModal);
  const { isPause, handlePause } = useCollection();

  const handleCloseModal = async () => {
    await analytics.track('webContentElementClicked', {
      content_source: window.location.href,
      element: 'Not now',
    });

    if (isPause) handlePause();
    closeModal();
  };

  const handleOpenStore = async () => {
    await analytics.track('webContentElementClicked', {
      content_source: window.location.href,
      element: 'Open Findies',
    });

    window.open(config.oneLinkUrl, '_blank');
  };

  const renderBodyCustom = () => {
    return (
      <BodyContainer>
        <Logo src={LogoImage} alt="Findies" />
        <Typography
          fontSize={16}
          fontWeight={600}
          sx={{ whiteSpace: 'pre-line' }}
          lineHeight="20px"
          textAlign="center"
        >
          {'Discover what others love\n and shop with cashback'}
        </Typography>
      </BodyContainer>
    );
  };

  const renderFooterCustom = () => {
    return (
      <ButtonContainer>
        <Button onClick={handleOpenStore} variant="contained" size="large">
          Open Findies
        </Button>
        <Button onClick={handleCloseModal} variant="text" size="large">
          Not now
        </Button>
      </ButtonContainer>
    );
  };

  return (
    <BaseModal
      open
      maxWidth="xs"
      renderHeaderCustom={() => null}
      renderBodyCustom={renderBodyCustom}
      renderFooterCustom={renderFooterCustom}
      PaperComponent={({ children, ...rest }) => (
        <GradientContainer {...rest}>
          <Container>{children}</Container>
        </GradientContainer>
      )}
    />
  );
};
